"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RemoveIconButton = exports.AddButton = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
const AddButton = exports.AddButton = (0, _mui.styled)(_components.Button)(({
  theme
}) => ({
  marginTop: theme.spacing(2),
  whiteSpace: 'nowrap'
}));
const RemoveIconButton = exports.RemoveIconButton = (0, _mui.styled)(_components.IconButton)({
  marginLeft: 'auto'
});
